import { EventEmitter } from '../utils/EventEmitter'
import {
  OperationContext,
  OperationSpec,
  OperationType,
} from './OperationContext'

export type OperationStatus =
  | 'pending'
  | 'running'
  | 'completed'
  | 'aborted'
  | 'error'

export const ErrorStatuses: OperationStatus[] = ['error', 'aborted']
export class RunnableOperation {
  public type: OperationType
  userOpSpec: OperationSpec
  operationId?: string
  aborted: boolean = false
  status: OperationStatus = 'pending'
  progress: number = 0
  emitter: EventEmitter
  constructor(protected spec: OperationSpec) {
    this.userOpSpec = spec
    this.operationId = spec.operationId
    this.type = spec.type
    this.emitter = new EventEmitter()
  }

  defineRequest(context: OperationContext): Promise<void> {
    this.setStatus('running')
    return Promise.resolve()
  }

  execute(context: OperationContext): Promise<void> {
    this.setStatus('running')
    return Promise.resolve()
  }

  setStatus(status: OperationStatus) {
    //console.log('🚀 ~ RunnableOperation ~ setStatus ~ status:', status)
    this.status = status
    if (status === 'completed' && this.progress !== 100) {
      this.setProgress(100)
    }
    this.emitter.emit('statusUpdate', status)
  }

  setProgress(progress: number) {
    this.progress = progress
    this.emitter.emit('progressUpdate', progress)
    if (this.progress === 100) {
      this.setStatus('completed')
    }
  }

  onStatusUpdate(callback: (status: OperationStatus) => void) {
    this.emitter.on('statusUpdate', callback)
  }

  onProgressUpdate(callback: (progress: number) => void) {
    this.emitter.on('progressUpdate', callback)
  }

  getProgress(): number {
    return this.progress
  }

  abort(): void {
    console.log('Aborted operation:', this.operationId)
  }
}
